/**
 * Combines arguments into a single, space-separated className string.
 * Supports strings, arrays, nested arrays, and conditional rendering of classes
 * via objects as {className: condition}. Falsy values are ignored.
 *
 * @example
 * getClassName('btn', { 'btn-active': true, 'btn-disabled': false }, null, ['custom-class'])
 * // Returns: 'btn btn-active custom-class'
 *
 * @param {...(string|Object|Array|boolean|null|undefined)} args - Class names, conditional objects, or arrays of them.
 * @returns {string} A space-separated string of valid class names.
 */
export const getClassName = (...args) => {
  const result = [];

  const process = (item) => {
    if (!item) {
      return;
    }

    if (typeof item === 'string') {
      result.push(item);
    } else if (Array.isArray(item)) {
      for (const nestedItem of item) {
        process(nestedItem);
      }
    } else if (typeof item === 'object') {
      for (const [className, condition] of Object.entries(item)) {
        if (condition) {
          result.push(className);
        }
      }
    }
  };

  for (const arg of args) {
    process(arg);
  }

  return result.join(' ');
};
